import { portRateConstants } from '../../_constants';
import { portRateServices } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const portRateActions = {
    getAllPortRates,
    getPortRates,
    createPortRate,
    updatePortRate,
    getPortRateById,
    deletePortRates,
    activation,
    searchPortRates,
    getPortListByCode,
    portRatesGroupByChargeCode,
    loadPortRatesByCharge,
};

function portRateFetching() { return { type: portRateConstants.PORT_RATE_FETCHING } }
function portRateFetched() { return { type: portRateConstants.PORT_RATE_FETCHED } }

function getAllPortRates() {
    return dispatch => {
        portRateServices.getAllPortRates()
            .then(
                portRates => dispatch(success(portRates)),
                error => dispatch(alertActions.error(error.toString()))
            );
    };
    function success(portRates) { return { type: portRateConstants.GET_ALL_PORT_RATES, portRates } }
}

function getPortRates(skip, take, filter, search) {
    return dispatch => {
        dispatch(portRateFetching());
        dispatch(userActions.allowLeavePage());
        portRateServices.getPortRates(skip, take, filter, search)
            .then(
                portRates => {
                    if (portRates.length > 0) {
                        dispatch(success(portRates));
                        dispatch(portRateFetched());
                    } else {
                        dispatch(portRateFetched());
                        dispatch(alertActions.warning(portRates.message))
                    }
                },
                error => {
                    dispatch(portRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(portRates) { return { type: portRateConstants.GET_PORT_RATES, portRates } }
}

function createPortRate(portRate, userProfile) {
    return dispatch => {
        dispatch(portRateFetching());
        dispatch(userActions.notallowLeavePage());
        portRateServices.createPortRate(portRate, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(portRateFetched());
                    dispatch(alertActions.success('Port rate added successfully'))
                    window.location.href = '/master_data/port_rate';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(portRateFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function updatePortRate(portRate, userProfile) {
    return dispatch => {
        dispatch(updatePortRate(portRate));
        dispatch(userActions.notallowLeavePage());
        portRateServices.updatePortRate(portRate, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Port rate updated successfully'))
                    window.location.href = '/master_data/port_rate/' + portRate.chargeCode;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function updatePortRate() { return { type: portRateConstants.UPDATE_PORT_RATE } }
}

function getPortRateById(id) {
    return dispatch => {
        dispatch(portRateFetching());
        portRateServices.getPortRateById(id)
            .then(
                portRate => {
                    dispatch(success(portRate))
                    dispatch(portRateFetched());
                },
                error => {
                    dispatch(portRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(portRate) { return { type: portRateConstants.GET_PORT_RATE_BY_ID, portRate } }
}

function deletePortRates(id, type, take) {
    return dispatch => {
        dispatch(portRateFetching());
        dispatch(userActions.notallowLeavePage());
        portRateServices.deletePortRates(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(portRateFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Port rates deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/port_rate';
                            break;
                        default:
                            window.location.href = '/master_data/port_rate';
                            // dispatch(getPortRates(0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(portRateFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    switch (type) {
                        case "specific":
                            dispatch(getPortRateById(id));
                            break;
                        default:
                            window.location.href = '/master_data/port_rate';
                            break;
                    }
                }
            );
    };
}

function activation(id, isActive) {
    return dispatch => {
        dispatch(portRateFetching());
        dispatch(userActions.notallowLeavePage());
        portRateServices.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(portRateFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getPortRateById(id));
                    dispatch(alertActions.success(isActive ? 'Port rate activated successfully' : 'Port rate deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(portRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

function searchPortRates(take, filter, search) {
    return dispatch => {
        dispatch(portRateFetching());
        portRateServices.searchPortRates(take, filter, search)
            .then(
                portRates => dispatch(searchPortRates(portRates)),
                error => {
                    dispatch(portRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function searchPortRates(portRates) { return { type: portRateConstants.SEARCH_PORT_RATES, portRates } }
}

function getPortListByCode(charge, branch) {
    return dispatch => {
        dispatch(portRateFetching());
        portRateServices.getPortListByCode(charge, branch)
            .then(
                portRate => {
                    dispatch(success(portRate));
                    dispatch(portRateFetched());
                },
                error => {
                    dispatch(portRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(portRate) { return { type: portRateConstants.GET_PORT_RATE_BY_ID, portRate } }
}

function portRatesGroupByChargeCode(skip, take, search) {
    return dispatch => {
        dispatch(portRateFetching());
        dispatch(userActions.allowLeavePage());
        portRateServices.portRatesGroupByChargeCode(skip, take, search)
            .then(
                portRatesCharge => {
                    if (portRatesCharge.length > 0) {
                        dispatch(success(portRatesCharge));
                        dispatch(portRateFetched());
                    } else {
                        dispatch(alertActions.warning(portRatesCharge.message))
                        dispatch(portRateFetched());
                    }
                },
                error => {
                    dispatch(portRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(portRatesCharge) { return { type: portRateConstants.PORTRATE_GROUP_BY_CHARGE, portRatesCharge } }
}

function loadPortRatesByCharge(charge, skip, take, search) {
    return dispatch => {
        dispatch(portRateFetching());
        dispatch(userActions.allowLeavePage());
        portRateServices.loadPortRatesByCharge(charge, skip, take, search)
            .then(
                portRates => {
                    if (portRates.length > 0) {
                        dispatch(success(portRates));
                        dispatch(portRateFetched());
                    } else {
                        dispatch(alertActions.warning(portRates.message))
                        dispatch(portRateFetched());
                    }
                },
                error => {
                    dispatch(portRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(portRates) { return { type: portRateConstants.PORTRATE_BY_CHARGE, portRates } }
}